"use client";

import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconExtension from "@/app/(components)/generics/Icons/IconExtension";
import { Tooltip, TooltipPosition, TooltipType } from "@/app/(components)/generics/Tootlip/Tooltip";
import { useAuthUser } from "@/app/(components)/specifics/wrappers/AuthProvider/AuthProvider";
import {
  useBrand,
  useCanManageCompany,
} from "@/app/(components)/specifics/wrappers/BrandProvider/BrandProvider";
import { useExtensionInstalled } from "@/app/hooks/useExtensionInstalled";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { URLs } from "@/app/utils/URLs";

import styles from "./InstallExtension.module.css";

type Props = {
  lang: string;
  text?: string;
};

export default function InstallExtension(props: Props) {
  const T = useT();
  const { text } = props;
  const user = useAuthUser();
  const isInstalled = useExtensionInstalled();
  const isTenant = useBrand() !== null;
  const canManageCompany = useCanManageCompany();

  if (isInstalled === null || isInstalled === true || !user || (isTenant && !canManageCompany)) {
    return null;
  }

  const openStore = () => window.open(URLs.extensionStore(), "_blank");

  if (text) {
    return (
      <Button
        type={ButtonType.PRIMARY}
        text={text}
        beforeIcon={<IconExtension size={18} />}
        isLink={false}
        min={true}
        onClick={openStore}
      />
    );
  }

  return (
    <Tooltip
      position={TooltipPosition.BOTTOM_LEFT}
      type={TooltipType.GREEN}
      content={T(TKey.INSTALL_EXTENSION_TOOLTIP)}
      trigger={
        <Button
          min={false}
          className={styles.button}
          type={ButtonType.PRIMARY}
          iconOnly={true}
          beforeIcon={<IconExtension size={18} />}
          isLink={false}
          onClick={openStore}
        />
      }
    />
  );
}
